'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var styles = ((_param)=>{
    var { radius, fit } = _param, focusRingOptions = _object_without_properties_loose(_param, [
        "radius",
        "fit"
    ]);
    return (theme)=>_extends({
            textDecoration: 'none',
            borderRadius: theme.fn.borderRadius(radius)
        }, fit && {
            display: 'flex',
            height: 'fit-content',
            width: 'fit-content'
        }, theme.fn.focusRing(_extends({}, focusRingOptions, {
            color: focusRingOptions.color || theme.palette.primary.mid
        })));
});

export { styles as default };
//# sourceMappingURL=Focusable.styles.js.map
